import React, { Component } from 'react';

import PracticeApi from '../../api/practice';
import Button from '../form/Button';
import Message from '../form/Message';

import PracticeAdminSelect from '../form/PracticeAdminSelect';

import { history } from '../../state/store';

class PracticeDetails extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            errorMessage: null,
            infoMessage: null,
            deleteErrors: null,
            isbusy: false,
            isdeleting: false,
            name: '',
            practice_lead: '',
            primary_practice: false,
            abbreviation: '',
        };

        this.deletePractice = this.deletePractice.bind(this);
        this.onChange = this.onChange.bind(this);
        this.savePractice = this.savePractice.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const current = this.props.practice;
        const next = nextProps.practice;
        if (next && (!current || next.id !== current.id)) {
            this.setState({
                name: next.name,
                practice_lead: next.practice_lead || '',
                primary_practice: next.primary_practice,
                abbreviation: next.abbreviation || '',
                errorMessage: null,
                infoMessage: null,
                deleteErrors: null,
                isbusy: false,
                isdeleting: false,
            });
        }
    }

    deletePractice() {
        if (window.confirm('WARNING!\n\nDeleting a Practice is a permanent, non-recoverable action.\n\nAre you sure you want to permanently delete this Practice and all associated data?')) {
            this.setState({ isdeleting: true, deleteErrors: null }, () => {
                PracticeApi.delete(this.props.practice.id)
                    .then(() => {
                        this.setState({ isdeleting: false });
                        this.props.onDelete();
                    })
                    .catch(err => {
                        this.setState({
                            isdeleting: false,
                            deleteErrors: 'Error deleting practice.',
                        });
                    });
            });
        }
    }

    savePractice() {
        const changes = {
            name: this.state.name,
            practice_lead: this.state.practice_lead || '',
            primary_practice: this.state.primary_practice,
            abbreviation: this.state.abbreviation || '',
        };
        this.setState({ errorMessage: null, infoMessage: null, isbusy: true }, () => {
            PracticeApi.update(this.props.practice.id, changes)
                .then(() => {
                    this.setState({
                        isbusy: false,
                        infoMessage: 'Changes saved.',
                    });
                    this.props.onUpdate(Object.assign({}, this.props.practice, changes));
                })
                .catch(err => {
                    this.setState({ errorMessage: err.message });
                });
        });
    }

    onChange(evt) {
        let changes = {};
        changes[evt.target.name] = evt.target.value;
        this.setState(changes);
    }

    render() {
        const practice = this.props.practice;

        if (!practice) {
            return <div className="ManagePage__details"></div>;
        }

        return (
            <div className="ManagePage__details">
                <form onSubmit={this.onFormSubmit}>
                    <div className="form__field">
                        <label htmlFor="name">Name</label>
                        <input type="text" name="name" value={this.state.name} onChange={this.onChange} />
                    </div>
                    <div className="form__checkbox">
                        <input
                            id="isPrimaryPractice"
                            name="isPrimaryPractice"
                            type="checkbox"
                            checked={this.state.primary_practice}
                            onChange={() => {
                                this.setState({
                                    primary_practice: !this.state.primary_practice,
                                });
                            }}
                        />
                        <label htmlFor="isPrimaryPractice">Primary Practice</label>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="form__field">
                                <label htmlFor="name">Abbreviation</label>
                                <input type="text" name="abbreviation" value={this.state.abbreviation} onChange={this.onChange} />
                            </div>
                        </div>
                    </div>
                    <div className="form__field">
                        <label htmlFor="projectLead">Practice Lead</label>
                        <PracticeAdminSelect
                            organization={practice.organization_id}
                            practice={practice}
                            value={this.state.practice_lead}
                            onSelect={email => {
                                this.setState({ practice_lead: email });
                            }}
                        />
                    </div>
                    <div className="form__footer">
                        <Message info={this.state.infoMessage} error={this.state.errorMessage} />
                    </div>
                    <div className="form__buttons">
                        <Button icon="fa-save" defaultText="Save Updates" busyText="Saving Updates..." isbusy={this.state.isbusy} onClick={this.savePractice} />
                    </div>
                </form>

                <hr />
                <div className="align-center">
                    <Button
                        size="small"
                        icon="fa-stethoscope"
                        defaultText={`View ${practice.name} Dashboard`}
                        onClick={() => {
                            history.push(`/practice/${practice.id}`);
                        }}
                    />
                </div>

                <hr />

                <h5>Danger Zone</h5>
                <p>If you would like to delete this practice from your organization, you can do so by clicking the button below. This will remove all progress and documents associated with this practice.</p>
                <Button size="small" danger="true" icon="fa-trash" defaultText="Delete Practice" busyText="Deleting Practice" isbusy={this.state.isdeleting} onClick={this.deletePractice} />
            </div>
        );
    }
}

export default PracticeDetails;
